var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape Copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 3C9.33333 1.89543 10.2288 1 11.3333 1C12.4379 1 13.3333 1.89543 13.3333 3V4.85714H18C18.5523 4.85714 19 5.30486 19 5.85714V10H17.5952C16.5301 10 15.6667 10.8635 15.6667 11.9286C15.6667 12.943 16.4498 13.7745 17.4445 13.8513L17.5952 13.8571H19V18C19 18.5523 18.5523 19 18 19H13.3333V17.1429C13.3333 16.0383 12.4379 15.1429 11.3333 15.1429C10.279 15.1429 9.41517 15.9587 9.33882 16.9936L9.33333 17.1429V19H5.33333C4.78105 19 4.33333 18.5523 4.33333 18V13.8571H2.92857C1.86345 13.8571 1 12.9937 1 11.9286C1 10.8635 1.86345 10 2.92857 10H4.33333V5.85714C4.33333 5.30486 4.78105 4.85714 5.33333 4.85714H9.33333V3Z",
    stroke: "#56CD9D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssets);
export default __webpack_public_path__ + "static/media/assets.a6c986dec31509a0e07b283bcdd9dc77.svg";
export { ForwardRef as ReactComponent };